import React, { useEffect, useState } from "react";
import "./App.scss";

import { displayNotificationDirectly, sendMessageViaServer, subscribeToWebpush } from "./WebpushFunc";

import { _common } from "./common";
const common = _common;




function Test() {

  function init() {
  }

  useEffect(() => {
    init();
  }, [])


  return (
    <div className="App" style={{
      overflow: "hidden",
      width: "100vw",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "white",
      justifyContent: "center",
      alignItems: "center",
    }}>

      Test

      <div style={{
        backgroundColor: "darkgreen",
        width: "100%",
        height: "70px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        flexShrink: "0"
      }}>
        <button className="button" style={{ backgroundColor: "orange" }}
          onClick={async () => {
            const user = JSON.parse(common.getUserFromLocalStorage());
            await sendMessageViaServer(user.memberId, "Hallo hier ist Michael");
          }}
        >
          Test Send Notification via Server
        </button>

        <button className="button" style={{ backgroundColor: "orange" }}
          onClick={() => {
            displayNotificationDirectly();
          }}
        >
          Notification direct
        </button>



      </div>
    </div>
  );
}

export default Test;
